import { apiClient } from './client'

/**
 * Fetch the current Flask-Login session user.
 * Returns null with a 401 when the user is not logged in.
 */
export async function getMe() {
  return apiClient('/auth/me')
}

/**
 * Register a new account via the JSON auth endpoint.
 * Logs the user in and sets the Flask session cookie on success.
 */
export async function register({ email, password, firstName, lastName, turnstileToken, acceptsTerms, marketingConsent }) {
  return apiClient('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, firstName, lastName, turnstileToken, acceptsTerms, marketingConsent }),
  })
}

/**
 * Log in with email and password via the JSON auth endpoint.
 * Sets the Flask session cookie on success.
 */
export async function login({ email, password, turnstileToken }) {
  return apiClient('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password, turnstileToken }),
  })
}

/**
 * Log out via the JSON auth endpoint.
 * Clears the Flask session cookie on success.
 */
export async function logout() {
  return apiClient('/auth/logout', {
    method: 'POST',
  })
}

/**
 * Request a password-reset email via the JSON auth endpoint.
 * Always succeeds from the caller's perspective to prevent enumeration.
 */
export async function restorePassword({ email }) {
  return apiClient('/auth/restore-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
}

/**
 * Change the password with a reset token via the JSON auth endpoint.
 */
export async function changePassword({ token, password }) {
  return apiClient('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
  })
}
